/* eslint-disable */
import { Card, CardContent, Box, InputAdornment } from '@mui/material';
import React, { useState, useEffect } from 'react';
import {
    Datagrid,
    TextField,
    TextInput,
    ReferenceInput,
    useRecordContext,
    ReferenceField,
    useRedirect,
    useStore,
    useGetOne,
    useDataProvider,
    Button,
    Loading,
    useRefresh
} from 'react-admin';
import { CloneButton } from '../../../lib/wrappers/actions';
import { useAzureADGroups } from '../../../msal/useAzureADGroups';
import { ReadOnlyContext } from '../../../lib/context/ReadOnlyContext';
import { ModuleFilterSidebar } from './ModuleFilterSidebar';
import { SwList } from '../../../lib/SwList';



export const RedirectToEditButtonNewWindow = ({ label, source, ...props }) => {
    const record = useRecordContext();
    return <Button label={label} variant="outlined" onClick={() => window.open(`/#/Module/${record.id}`, '_blank')} />;
};

export const CourseLinkField = ({ label, source }) => {
    const redirect = useRedirect();
    const record = useRecordContext();

    const [_, setCourseListParams] = useStore('Course.listParams');

    if (record && record[source]) {
        const onClick = (e) => {
            e.stopPropagation();
            let id = record[source];
            if(id?.length == 10){
                id = id.substring(0, id.length - 1)
            }
            setCourseListParams({
                displayedFilters: {},
                filter: { q: id },
            });

            redirect('list', 'Course');
        };
        return <Button variant="outlined" onClick={onClick} label={label} />;
    }
    return null;
};
const ModuleSearch = (props) => {
    const { canEditCourseAndModule } = useAzureADGroups();
    const refresh = useRefresh();
    return (
        <>
            <ReadOnlyContext.Provider value={!canEditCourseAndModule}>
                <SwList {...props} aside={<ModuleFilterSidebar />} filterDefaultValues={{ isClosed: false }} >
                    <Datagrid sort={false}
                        rowClick={false}
                        bulkActionButtons={!canEditCourseAndModule ? false : undefined}
                        >
                        <TextField source="shortTitle" label="Module Title" />
                        <TextField source="moduleCode" />
                        <TextField source="id" />
                        <ReferenceField
                            label="Credit Value"
                            reference="CreditValue"
                            source="creditValueId"
                            link={false}
                        >
                            <TextField source="creditvalue" />
                        </ReferenceField>
                        <ReferenceField
                            label="Credit Level"
                            reference="CreditLevel"
                            source="creditLevelId"
                            link={false}
                        >
                            <TextField source="Title" />
                        </ReferenceField>
                        <ReferenceField
                            label="Status"
                            reference="Status"
                            source="statusId"
                            link={false}
                        >
                            <TextField source="Title" />
                        </ReferenceField>
                        <RedirectToEditButtonNewWindow label={canEditCourseAndModule ? "Edit" : "View"} {...props} />
                        <CourseLinkField label="Courses" source="id" />
                        <CloneButton label="Copy" />
                    </Datagrid>
                </SwList>
            </ReadOnlyContext.Provider>
        </>
    );
};



export default ModuleSearch;

